import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from '@/lib/queryClient'
import { installStaleChunkReload } from '@/lib/chunkReload'
import { installNewVersionWatch } from '@/lib/versionWatch'
import { installSupabaseApiBearer } from '@/lib/apiBearer'
// Side-effect import: populates the integration adapter registry. WITHOUT this
// line `getAdapter('payroll.adp')` returns null forever, silently. See
// integrations/registerAdapters.ts.
import '@/integrations/registerAdapters'
import App from './App'
import { APP_IDENTITY } from '@/config/appIdentity'
import './styles/globals.css'

// #111 workstream A — set the document title from the configurable app identity
// so a fork rebrands via VITE_APP_TITLE without editing index.html.
document.title = APP_IDENTITY.title

// Attach the caller's Supabase token to same-origin /api/* requests. Must run
// before anything can fetch: the SAP proxy and ERP-sync endpoints now refuse
// an unauthenticated call. No-op on Entra builds, which have their own.
installSupabaseApiBearer()

// Auto-recover from stale lazy-chunk fetches after a deploy (every route).
installStaleChunkReload()

// Tell a tab left open across a deploy that a new version is out (Reload toast).
installNewVersionWatch()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
)
